import React from 'react'
import { Global, css } from '@emotion/core'

const GlobalCss = () => <Global
styles={css`
  @import url('https://fonts.googleapis.com/css2?family=Maitree:wght@200;300&family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap');
  .individuals-page {
    .nav-container .logo svg .shadow { fill: #FF81F2; }
  }
  .businesses-page {
    .nav-container .logo svg .shadow { fill: #00ADEE; }
  }
  .schools-page {
    .value-prop .content {
      font-size: 0.9rem;
    }
    .circles { margin-top: -45vh; }
  }
`}
/>

export default GlobalCss